
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"oeamtc-icon__edit","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.17 11.93l-.67.67L3 13l.4-2.5.67-.67zM4.79 9.11l4-4 .51-.51 1.06-1.06 2.1 2.1-1 1-.53.53-4 4zm6.3-6.3l.35-.35a1.49 1.49 0 112.15 2.05h-.05l-.35.35z"}})])
          )
        }
      }
    